import { __ } from '@wordpress/i18n';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

const Save = () => {

    const blockProps = useBlockProps.save( );
    const innerBlocksProps = useInnerBlocksProps.save( blockProps );
 
    return <div {...innerBlocksProps} />
};

export default Save;